import { OperationType } from './../widgets/filters/miscellaneous/operation-type.enum';
import { HttpParams } from '@angular/common/http';
import { QueryFilterParameter } from '../widgets/filters/models/query-filter-parameter.model';

export class GridHelper {

  static prepareQueryRequest(loadOptions: any): TableQueryOptions {
    const params = this.getHttpParams(loadOptions);
    const options = new TableQueryOptions();
    const keys = params.keys();

    
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const value = params.get(key);
      if (key === 'sort') {
        const valueConvert = JSON.parse(value);
        const sort = new QuerySortParams();
        sort.selector = valueConvert[0].selector;
        sort.desc = valueConvert[0].desc;
        options.sort = sort;
      }

      if (key === 'filter') {
        const valueConvert = JSON.parse(value);
        const filters: QueryFilterParameter[] = [];

        for (let i = valueConvert.length - 1; i--;) {
          if (valueConvert[i] === 'and') valueConvert.splice(i, 1);
        }

        if (typeof valueConvert[0] === "string") {
          const filter = new QueryFilterParameter(
						valueConvert[0],
						valueConvert[2],
						this.filterOptionsMap(valueConvert[1])
					);

          filters.push(filter);
        } else if (typeof valueConvert[0] === "object") {
          for (let index = 0; index < valueConvert.length; index++) {
            const filter = new QueryFilterParameter(
							valueConvert[index][0],
							valueConvert[index][2],
							this.filterOptionsMap(valueConvert[index][1])
						);

            filters.push(filter);
          }
        }
				
        options.columnsFilters = filters;
      }
      if (key !== 'filter' && key !== 'sort') {
        options[key] = value;
      }
    }
    return options;
  }

  private static getHttpParams(loadOptions: any) {
    let params: HttpParams = new HttpParams();
    const filterParams =
      [
        'skip',
        'take',
        'requireTotalCount',
        'requireGroupCount',
        'sort',
        'filter',
        'totalSummary',
        'group',
        'groupSummary'
      ];

    filterParams.forEach((i) => {
      if (i in loadOptions && this.isNotEmpty(loadOptions[i])) {
        params = params.set(i, JSON.stringify(loadOptions[i]));
      }
    });

    return params;
  }

  private static isNotEmpty(value: any): boolean {
    return value !== undefined && value !== null && value !== '';
  }

  public static generateFilterConditionByColumnFilters(filters: any, isRecursionCall: boolean): (item: any) => boolean | null {
    if (!filters) {
      return null;
    }

    let condition = '';
    let simpleCondition = filters.filter(item => (item instanceof Array)).length < 1;
    
    if (simpleCondition) {
      condition = this.generateSimpleCondition(filters);
    } else {
      for (let i = 0; i < filters.length; i++) {
        const simpleFilters = filters[i];

        if (simpleFilters instanceof Array) {
          let simpleCondition = null;
          if (!(simpleFilters[0] instanceof Array)) {
          simpleCondition = this.generateSimpleCondition(simpleFilters);
          } else {
            simpleCondition = this.generateFilterConditionByColumnFilters(simpleFilters, true);
          }
    
          if (!simpleCondition) {
            continue;
          }
          
          condition += simpleCondition;
        } else {
          condition += simpleFilters === 'and' ? ' && ' : ' || ';
        }
      }
    }

    condition = isRecursionCall ? `(${condition})` : `(item) => ${condition}`;

    return isRecursionCall ? condition : eval(condition);
  }

  private static generateSimpleCondition(filters: any): string {
    if (!filters || filters.length < 3) {
      return '';
    }

    let columnName = filters[0];
    let operation = GridHelper.filterOptionsMap(filters[1]);
    let value = filters[2];

    return this.combineFilter(columnName, operation, value);
  }

  private static filterOptionsMap(type: string): OperationType {
    switch (type) {
      case 'contains': {
        return OperationType.Contains;
      }
      case 'notcontains': {
        return OperationType.NotContains;
      }
      case 'startswith': {
        return OperationType.StartsWith;
      }
      case 'endswith': {
        return OperationType.EndsWith;
      }
      case '=': {
        return OperationType.Equals;
      }
      case '<>': {
        return OperationType.NotEquals;
      }
      case 'or': {
        return OperationType.Or
      }
      case 'and': {
        return OperationType.And
      }
    }

		return undefined;
  }

  private static combineFilter(columnName: string, operation: OperationType, value: string): string {
    switch (operation) {
      case OperationType.Contains: {
        return `item.${columnName}.indexOf('${value}') > -1`;
      }
      case OperationType.NotContains: {
        return `item.${columnName}.indexOf('${value}') < 0`;
      }
      case OperationType.StartsWith: {
        return `item.${columnName}.startsWith('${value}')`;
      }
      case OperationType.EndsWith: {
        return `item.${columnName}.endsWith('${value}')`;
      }
      case OperationType.Equals: {
        return `item.${columnName} == '${value}'`;
      }
      case OperationType.NotEquals: {
        return `item.${columnName} != '${value}'`;
      }
    }

		return null;
  }

  public static sortRecord(e, data): any[] {
    let dataSorting = data;
    if (e.component.getDataSource() != null && e.component.getDataSource().sort() != null) {
      if (e.component.getDataSource().sort().length > 0) {
        e.component.getDataSource().sort().forEach(element => {
          if (element != null && element.selector != null) {
            if (element.desc) {
              dataSorting = Object.values(data).sort(
                (a, b) => (a[element.selector] < b[element.selector]) ? 1 : -1
              );
            }
            else {

              dataSorting = Object.values(data).sort(
                (a, b) => (a[element.selector] > b[element.selector]) ? 1 : -1
              );
            }
          }
        });
      }
    }
    return dataSorting;
  }
}

export class TableQueryOptions {
  skip: number;
  take: number;
  sort: QuerySortParams;
  columnsFilters: QueryFilterParameter[];
}

export class QuerySortParams {
  selector: string;
  desc: boolean;
}
